/**
 * AI 调用日志服务
 */

import { apiClient } from '../config/netConfig';
import type { AiCallLog, ApiResponse, PaginatedResponse } from '../types';

export const aiLogService = {
  /**
   * 获取日志列表
   */
  async getLogs(params?: {
    page?: number;
    pageSize?: number;
    resourceId?: string;
    ruleId?: string;
    serviceName?: string;
    status?: string;
    accessTag?: string;
    accessType?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<PaginatedResponse<AiCallLog>> {
    const response = await apiClient.get<ApiResponse<PaginatedResponse<AiCallLog>>>(
      '/api/ai/logs',
      { params }
    );
    return response.data.data;
  },

  /**
   * 获取统计信息
   */
  async getStats(params?: {
    startDate?: string;
    endDate?: string;
    groupBy?: string;
  }): Promise<any> {
    const response = await apiClient.get<ApiResponse<any>>(
      '/api/ai/logs/stats',
      { params }
    );
    return response.data.data;
  },

  /**
   * 获取单个日志
   */
  async getLogById(id: string): Promise<AiCallLog> {
    const response = await apiClient.get<ApiResponse<AiCallLog>>(
      `/api/ai/logs/${id}`
    );
    return response.data.data;
  },
};
